import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import rootReducer from './_redux/store'
import './translation/translate';
import './index.css';

// create tha app global store
const store = rootReducer()
ReactDOM.render(
  <Provider store={store} >
    <App />
  </Provider>,
  document.getElementById('root')
)